/**
 * @generated SignedSource<<d31dde5a701c53e78631d96411705f20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DisconnectSlackUserMutation$variables = {
  userId: string;
};
export type DisconnectSlackUserMutation$data = {
  readonly disconnectSlack: {
    readonly __typename: "ForbiddenError";
    readonly reason: string;
  } | {
    readonly __typename: "SlackDisconnected";
    readonly message: string;
    readonly success: boolean;
    readonly userId: string;
  } | {
    readonly __typename: "ValidationError";
    readonly reason: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type DisconnectSlackUserMutation = {
  response: DisconnectSlackUserMutation$data;
  variables: DisconnectSlackUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reason",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "disconnectSlack",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "type": "SlackDisconnected",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "ForbiddenError",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "ValidationError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisconnectSlackUserMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisconnectSlackUserMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d114cb0f5b8e1bfbb81b96b1771d0223",
    "id": null,
    "metadata": {},
    "name": "DisconnectSlackUserMutation",
    "operationKind": "mutation",
    "text": "mutation DisconnectSlackUserMutation(\n  $userId: ID!\n) {\n  disconnectSlack(userId: $userId) {\n    __typename\n    ... on SlackDisconnected {\n      success\n      userId\n      message\n    }\n    ... on ForbiddenError {\n      reason\n    }\n    ... on ValidationError {\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4bb4ab47fd0b6293e8c49b4ea1a0926";

export default node;
